import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useEffect, useState } from 'react'
import { change } from 'redux-form'
import pick from 'lodash/pick'
import {
  CREATE_MULTIPLE_ACCOUNTS,
  CREATE_NEW_ACCOUNT,
} from 'modules/Services/types'

export const useAccountCreateFormSubmit = (
  form,
  onClose,
  multiLogins = false,
) => {
  const dispatch = useDispatch()
  const [submitted, setSubmitted] = useState(false)

  const { values = {}, registeredFields } = useSelector(
    (state) => state.form[form],
  )

  useEffect(() => {
    if (submitted) {
      setSubmitted(false)
    }
  }, [values])

  const submitData = useCallback(
    (values) => {
      const updateLoginsState = (response) =>
        Object.entries(response).forEach(([i, { created = false }]) =>
          dispatch(
            change(
              form,
              `logins[${i}]`,
              {
                ...values.logins[i],
                created,
              },
              false,
              true,
            ),
          ),
        )

      //need to send data from currently registered form fields only!
      const registerFieldsNames = Object.keys(registeredFields)

      return multiLogins
        ? new Promise((resolve, reject) =>
            dispatch({
              meta: { resolve, reject },
              type: CREATE_MULTIPLE_ACCOUNTS,
              payload: {
                data: {
                  ...pick(values, registerFieldsNames),
                  logins: values.logins.filter(({ created }) => !created),
                },
                formName: form,
              },
            }),
          )
            .then(updateLoginsState)
            .catch(({ accountStates, error }) => {
              updateLoginsState(accountStates)
              throw error
            })
            .finally(() => {
              setSubmitted(true)
            })
        : new Promise((resolve, reject) =>
            dispatch({
              meta: { resolve, reject },
              type: CREATE_NEW_ACCOUNT,
              payload: {
                data: pick(values, registerFieldsNames),
                formName: form,
              },
            }),
          ).then(() => {
            onClose()
            global.yaCounter32793525 &&
              global.yaCounter32793525.reachGoal('new-network-account')

            global.dataLayer &&
              global.dataLayer.push({ event: 'new-network-account' })
          })
    },
    [form, onClose, multiLogins],
  )

  submitData.submitted = submitted

  return submitData
}
